<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_defect') : $t('labels.add_defect') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pr-3 mb-4">
              <label>{{$t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="defect_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.defect_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('defect_name') }}</span>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pl-3 mb-4">
              <label class="bold-fields">{{ $t('labels.code')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="code"
                maxlength="20"
                v-model="code"
                :placeholder="$t('labels.defect_code')"
                icon-no-border
                v-validate="'required'"
                height="150"
              />
              <span class="text-danger text-sm">{{ errors.first('code') }}</span>
            </div>
            <div class="vx-col sm: w-full p-0">
              <label class="bold-fields">{{ $t('labels.description')}}</label>
              <vs-textarea
                type="text"
                class="w-full mb-0 mt-1"
                name="description"
                :placeholder="$t('labels.description')"
                maxlength="5000"
                v-model="description"
                icon-no-border
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('description') }}</span>
            </div>
          </div>
          <!-- Services -->
          <div class="vx-row mt-4">
            <div class="vx-col w-full px-4">
              <label class="bold-fields">{{ $t('labels.services')}}</label>
              <ul class="centerx flex mt-2">
                <li class="mr-4">
                  <vs-radio v-model="services" vs-value="ASR">{{ $t('labels.all') }}</vs-radio>
                </li>
                <li class="mr-4 ml-3">
                  <vs-radio v-model="services" vs-value="SSR">{{ $t('labels.specific_to_service') }}</vs-radio>
                </li>
              </ul>
            </div>
            <div class="vx-col w-full px-4 mt-3 mb-4" v-if="services !== 'ASR'">
              <v-select
                multiple
                v-model="service"
                :options="services_drop"
                :reduce="services_drop => services_drop.id"
                label="name"
                name="services"
                v-validate="'required'"
                :closeOnSelect="false"
              />
              <span class="text-danger text-sm">{{ errors.first('services') }}</span>
            </div>
          </div>
          <div class="mt-2 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-defect"
              button="submit"
            >{{ editRoute ? $t('labels.update_defect') : $t('labels.add_defect') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      name: "",
      service: [],
      services_drop: [],
      services: "ASR",
      description: "",
      code: ""
    };
  },
  components: {
    "v-select": vSelect
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getServices();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getDefects();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateDefect();
        }
      });
    },
    // API Integration for add-update top-events
    async createUpdateDefect() {
      let input = {
        name: this.name,
        description: this.description,
        code: this.code
      };
      if (this.services == "ASR") {
        input.all_services = true;
      } else {
        input.all_services = false;
        input.service_ids = this.service;
      }
      let url = this.editRoute
        ? "/defects/update/" + this.editRoute
        : "/defects/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-defect",
        true
      );
      if (response) {
        this.$router.push({ name: "Defects" });
      }
    },
    async getDefects() {
      let response = await this.getHTTPGetResponse(
        "/defects/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let defect = data.defect;
        this.name = defect.name;
        this.code = defect.code;
        this.description = defect.description;
        this.services = defect.all_services == false ? "SSR" : "ASR";
        let services = defect.services;
        services.forEach(element => {
          this.service.push(element.id);
        });
      }
    },
    // API Integration for services
    async getServices() {
      let input = {
        name: this.service
      };
      let response = await this.getHTTPPostResponse("/services/list", input);
      if (response) {
        let service_req = response.data.services;
        let filteredServices = [];
        for (var i = 0; i < service_req.length; i++) {
          let obj = { id: service_req[i].id, name: service_req[i].name };
          filteredServices.push(obj);
        }
        this.services_drop = filteredServices;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>